import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const Timer = ({ timeRemaining, showWarning = false, onTimeUp }) => {
  const [displayTime, setDisplayTime] = useState(timeRemaining);

  useEffect(() => {
    setDisplayTime(timeRemaining);
  }, [timeRemaining]);

  useEffect(() => {
    if (displayTime <= 0 && onTimeUp) {
      onTimeUp();
    }
  }, [displayTime, onTimeUp]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    if (hours > 0) {
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const isWarning = showWarning || timeRemaining <= 300; // 5 minutes

  return (
    <div className={`flex items-center space-x-2 ${isWarning ? 'timer-warning' : 'text-gray-700'}`}>
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span className="font-mono text-lg font-semibold">
        {formatTime(displayTime)}
      </span>
      {isWarning && (
        <span className="text-xs">remaining</span>
      )}
    </div>
  );
};

Timer.propTypes = {
  timeRemaining: PropTypes.number.isRequired, // in seconds
  showWarning: PropTypes.bool,
  onTimeUp: PropTypes.func,
};

Timer.defaultProps = {
  showWarning: false,
};

export default Timer; 